import { Component, Input, OnInit, HostListener } from "@angular/core";
import { environment } from "@edp-environments/environment";
import { Store } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { Menu } from "@edp-models/menu.model";
import { getMainMenu } from "@edp-store/selectors/layout.selectors";
import { Router } from "@angular/router";
import { IAppEsState } from "@edp-store/state/ES/app-es.state";
import { getContractEs } from "@edp-store/selectors/ES/contract-es.selectors";
import { ContractEs } from "@edp-models/ES/es-contract.model";
import { OperationHistoryService } from "@edp-services/operation-history.service";

@Component({
    selector: "edp-es-contract-consumption-local",
    templateUrl: "./edp-es-contract-consumption-local.component.html",
    styleUrls: ["./edp-es-contract-consumption-local.component.scss"],
})
export class EdpEsContractConsumptionLocalComponent implements OnInit {
    public contract: ContractEs;
    public isApp: boolean;
    public scroll: boolean;
    public showContractName: boolean;
    public menuTitle: string;

    @HostListener("window:scroll", [])
    onScroll(): void {
        if (window.scrollY === 0) {
            this.scroll = false;
        } else {
            this.scroll = true;
        }
    }

    constructor(
        private store: Store<IAppState>,
        private storeEs: Store<IAppEsState>,
        private router: Router,
        private operationHistoryService: OperationHistoryService
    ) {}

    ngOnInit() {
        this.isApp = environment.isApp;
        this.store.select(getMainMenu).subscribe((menu: Menu[]) => {
            menu.forEach(menuItem => {
                if (menuItem.isActive) {
                    this.menuTitle = menuItem.name;
                    this.showContractName = ["MENU.ENERGY-E", "MENU.ENERGY-SOLAR"].includes(menuItem.name);
                }
            });
        });

        this.storeEs.select(getContractEs).subscribe((contract: ContractEs) => {
            if (!!contract) {
                this.contract = contract;
            }
        });
    }

    public showContractList() {
        this.sendOperationHistoryService("LOCATION_MENU_TAB");
        this.router.navigate([`/locais-consumo/${this.contract.id}/inicio`]);
    }
    private sendOperationHistoryService(key: string, value: string | null = null) {
        this.operationHistoryService.registerWithContract(this.contract.id, key, value, null, null, false);
    }
}
